import React from "react";

import { Character } from "../types";

const statusStyles: Record<string, string> = {
  Alive: "bg-portal-400/15 text-portal-400",
  Dead: "bg-red-500/15 text-red-400",
  unknown: "bg-white/10 text-slate-300",
};

const CharacterList: React.FC<{ characters: Character[] }> = ({
  characters,
}) => {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {characters.map((character) => (
        <article
          key={character.id}
          className="group overflow-hidden rounded-xl border border-white/10 bg-space-800 transition hover:-translate-y-0.5 hover:border-portal-400/50 hover:shadow-xl hover:shadow-black/40"
        >
          <img
            src={character.image}
            alt={character.name}
            loading="lazy"
            className="h-48 w-full object-cover"
          />
          <div className="p-4">
            <h3 className="truncate font-semibold text-white" title={character.name}>
              {character.name}
            </h3>
            <span
              className={`mt-2 inline-block rounded-md px-2 py-1 text-xs font-medium ${
                statusStyles[character.status] ?? statusStyles.unknown
              }`}
            >
              {character.status}
            </span>
            <p className="mt-3 text-sm text-slate-400">
              {character.species} · {character.gender}
            </p>
          </div>
        </article>
      ))}
    </div>
  );
};

export default CharacterList;
